import $ from "jquery"
import { trace } from "./../shared/helpers.js"

// Alert Article (Home)
// with cookie
const AlertBox = {

  // ### init ###
  init() {
    $('body').on('click', '[data-dismiss]', (e)=> {
      e.preventDefault();
      let $btn = $(e.target);
      let myID = $btn.data("dismiss");      
      $.getJSON("/o/cookie_alert_dismiss.json", {id: myID}, (result)=> {
        trace(result);
        let $alert = $('#' + myID);
        if ($alert.length) {
          $alert.collapse('hide');
        }
      }).fail(trace);
    });
  }

}

export default AlertBox;